module.exports = __webpack_public_path__ + "img/BACKGROUND-PLATINUM-nogutter.ca2f6050.jpg";